export default __webpack_public_path__ + "static/media/286.3edde714.jpg";